module.exports = __webpack_public_path__ + "img/cyfx.225e37b1.png";